<template>
  <div>
    <v-row no-gutters>
      <v-col v-if="breadCrumbs" cols="12">
        <v-card flat>
          <v-breadcrumbs :items="breadCrumbs" class="body-1 pa-2">
            <template slot="item" slot-scope="props">
              <span
                :class="
                  props.item.disabled
                    ? 'grey--text'
                    : 'indigo--text text--accent-2 pointer'
                "
                @click="$router.push(props.item.to)"
                v-text="props.item.text"
              ></span>
            </template>
            <v-icon
              slot="divider"
              v-text="$getIcon('mdiChevronRight')"
            ></v-icon>
          </v-breadcrumbs>
        </v-card>
      </v-col>
    </v-row>
    <v-speed-dial absolute fixed right bottom class="mb-3">
      <template v-slot:activator>
        <v-btn color="green" dark fab @click="showLogForm = true">
          <v-icon size="35" class="mx-1" v-text="$getIcon('mdiPlus')"></v-icon>
        </v-btn>
      </template>
    </v-speed-dial>
    <v-row no-gutters>
      <v-col cols="12">
        <slot></slot>
      </v-col>
    </v-row>
    <v-navigation-drawer
      v-model="showLogForm"
      width="720"
      fixed
      right
      height="100vh"
      temporary
      light
      stateless
    >
      <template v-slot:prepend>
        <v-card tile>
          <vue-card-title
            :title="`Add Communication Log`"
            :subtitle="`Here you can create communication log with client.`"
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            dark
            @close="showLogForm = false"
          >
          </vue-card-title>
        </v-card>
      </template>

      <log-form
        v-if="showLogForm"
        @close="showLogForm = false"
        @success="showLogForm = false"
      ></log-form>
    </v-navigation-drawer>
  </div>
</template>
<script>
import LogForm from "@/components/crm/client/components/updatedLogForm";
import VueCardTitle from "./VueCardTitle";

export default {
  components: { LogForm, VueCardTitle },
  props: {
    title: {
      type: String,
      required: true
    },
    extraInfo: {
      type: String,
      default: ""
    },
    breadCrumbs: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      showLogForm: false
    };
  },
  mounted() {
    document.title = `${this.title} | RealCRMsoft | Complete CRM Intelligence`;
    this.breadCrumbs.unshift({
      text: this.$store.state.shell.currentOrganizationName,
      disabled: false,
      to: {
        name: "overview",
        params: { slug: this.$route.params.slug }
      }
    });
  }
};
</script>
